<template>
  <div
    class="menu-children-item"
    :style="{
      paddingLeft: `${padding}px`
    }"
  >
    <template v-if="menuItem.childMenuList?.length">
      <div
        class="menu-children-title"
        style="display: block"
        :title="menuItem.menuName"
        v-if="menuItem.menuName"
      >
        {{ menuItem.menuName }}
      </div>
      <MenuChildren
        v-for="item in menuItem.childMenuList"
        :key="item.menuId"
        :menuItem="item"
        :padding="padding + 6"
        @menuClick="$emit('menuClick')"
      />
    </template>
    <template v-else>
      <div
        :title="menuItem.menuName"
        :class="{
          'is-active': active,
          'no-child': menuItem.level === 3,
          'menu-children-title': menuItem.level === 3,
          'menu-children-route': menuItem.level !== 3
        }"
        :style="{
          paddingRight: `32px`
        }"
        @click="handleClick()"
      >
        <div class="menu-text">{{ menuItem.menuName }}</div>
        <div class="new-menu" v-if="menuItem.isNew">NEW</div>
        <MenuCollect
          :menuItem="menuItem"
          :class="['icon-star', getCollectStatus(menuItem) ? 'collect-item' : null]"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import MenuCollect from '@/components/Layout/MenuCollect.vue'

export default defineComponent({
  name: 'MenuChildren',
  data() {
    return {}
  },
  props: {
    menuItem: Object,
    padding: {
      type: Number,
      default: -6
    }
  },
  inject: ['selectChange'],
  components: { MenuCollect },
  computed: {
    active() {
      return this.menuItem.menuRouteUrl === this.$route.path
    }
  },
  methods: {
    handleClick() {
      if (!this.menuItem.menuRouteUrl) return
      this.selectChange(this.menuItem.menuRouteUrl)
      this.$emit('menuClick')
    },
    getCollectStatus(item) {
      return this.$store.state.menu.collectList.some(menu => menu.menuId === item.menuId)
    }
  }
})
</script>

<style lang="scss" scoped>
.menu-children-title,
.menu-children-route {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 14px;
  font-size: 14px;
  position: relative;
  display: flex;
  align-items: center;
  .menu-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:hover {
    .icon-star {
      opacity: 1;
    }
  }
}
.menu-children-title {
  color: #101d49;
  position: relative;
  line-height: 32px;
  &::before {
    content: '';
    display: inline-block;
    height: 6px;
    width: 6px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto 0;
    background-color: #aeb7d1;
    border-radius: 50%;
  }
  &.no-child {
    cursor: pointer;
    &::before {
      content: '';
      display: none;
    }
    &:hover {
      background-color: #f4f7ff;
      font-weight: 600;
    }
    &.is-active {
      background-color: #f4f7ff;
      font-weight: 600;
    }
  }
}
.menu-children-route {
  cursor: pointer;
  padding-right: 24px;
  line-height: 34px;
  color: #6c748b;
  margin-bottom: 4px;
  &.is-active {
    color: #1d4cd2;
    background-color: #f4f7ff;
    font-weight: 600;
  }
  &:hover {
    color: #1d4cd2;
    background-color: #f4f7ff;
    font-weight: 600;
  }
}
.icon-star {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0px;
  &.collect-item {
    opacity: 1;
  }
}
</style>
